// @ts-nocheck
import { useState, useEffect } from 'react';
import { supabase } from '@/lib/supabase';
import { toast } from 'sonner';

interface Role {
  slug: string;
  name: string;
  dashboard_path?: string;
}

interface Membership {
  slug: string;
  name: string;
  is_active: boolean;
  is_premium?: boolean;
  gated_modules?: string[];
  is_addon?: boolean;
  role_slug?: string;
}

export const useRolesAndMemberships = () => {
  const [roles, setRoles] = useState<Role[]>([]);
  const [memberships, setMemberships] = useState<Membership[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);
        setError(null);

        // Roles table dropped — use hardcoded list from rolePaths.ts
        const { DASHBOARD_PATH_BY_ROLE } = await import('@/lib/rolePaths');
        const rolesData = Object.entries(DASHBOARD_PATH_BY_ROLE).map(([slug, dashboard_path]) => ({
          slug,
          name: slug.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase()),
          dashboard_path,
        }));

        // Fetch active memberships
        const { data: membershipsData, error: membershipsError } = await supabase
          .from('memberships')
          .select('slug, name, is_active, is_premium, gated_modules, is_addon, role_slug')
          .eq('is_active', true)
          .order('name');

        if (membershipsError) {
          console.error('Error fetching memberships:', membershipsError);
          throw membershipsError;
        }

        // Filter out any roles/memberships with empty or null slugs to prevent Select component errors
        const validRoles = (rolesData || []).filter(role => role.slug && role.slug.trim() !== '');
        const validMemberships = (membershipsData || []).filter(m => m.slug && m.slug.trim() !== '');
        
        setRoles(validRoles);
        setMemberships(validMemberships);
      } catch (err) {
        console.error('Error fetching roles and memberships:', err);
        setError('Failed to load roles and memberships');
        toast.error('Failed to load roles and memberships');
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  return {
    roles,
    memberships,
    isLoading,
    error,
  };
};
